(function ($) {
  var descriptionHeightP = '';
  var descriptionTextHeight = '';
  var lineHeight = '';
  var dataHeight = '';
  $(document).ready(function() {
      // fix bug menu not show on click - header menu
      jQuery('[aria-controls="nav-drawer"]').click(function(){
          jQuery('#nav-drawer').toggleClass('cv-h');
          jQuery('#nav-drawer').toggleClass('is-open-menu');
      });

      //Hide collection in breadcrumb when redirect from any page (not from collection)
      if (window.location.href.indexOf('/products') !== -1 && window.location.href.indexOf('/collections') === -1) {
          jQuery('body').addClass('hide-collection-breadcrumb');
      }      

      if($('.product__selectors .radio__fieldset .radio__button').length){
        $('.product__selectors .radio__fieldset .radio__button').each(function(){
          var radioLable = $(this).find('.radio__label span').text();
          var suffix = radioLable.match(/\d+/);
          $(this).css('order', suffix);
        })
      }
 
    
      $('body').click(function(event) {
        if($(this).hasClass('PickupAvailabilityModal-open')){
          if (!$(event.target).closest(".pickup-availabilities-modal").length) {
              $("body .pickup-availabilities-modal__close").trigger('click');
          }
        }
      });
    
      $('.variant-box-item .show-all-button a').click(function(e){
        e.preventDefault();
        $(this).parent().hide();
        $('.variant-box-item .hide-all-button').show();
        $(this).parents('.variant-box-item').find('.box-item').show();
        $(this).parents('.variant-box-item').find('.box-item').each(function(){
          $(this).find('.box-image img').attr('src', $(this).find('.box-image img').attr('data-src'));
        });
      })
      $('.variant-box-item .hide-all-button a').click(function(e){
        e.preventDefault();
        $(this).parent().hide();
        $('.variant-box-item .show-all-button').show();
        $(this).parents('.variant-box-item').each(function(){
          $('.variant-box-item .box-item').each(function(){
            if(($(this).index() + 1) > 8){
              $(this).attr('src', '').hide();
            }
          })
        });
      })
      $('.product__selectors .radio__fieldset .radio__button').on('click', function(){
        $('.variant-box-item').hide();
        $('.variant-box-item .show-all-button').show();
        $('.variant-box-item .box-item .box-image img').attr('src', '');
        $('.variant-box-item .box-item').each(function(){
          if(($(this).index() + 1) > 8){
            $(this).hide();
          }
        })
        setTimeout(function(){
          $('.variant-box-item').each(function(){
            if($(this).attr('data-variant-id') == getUrlParameter('variant')){
              $(this).show();
              $(this).find('.box-item').each(function(){
                if(($(this).index() + 1) < 9){
                  $(this).find('.box-image img').attr('src', $(this).find('.box-image img').attr('data-src'));
                }
              })
            }
          })
        }, 500)
      })
    
      var getUrlParameter = function getUrlParameter(sParam) {
          var sPageURL = window.location.search.substring(1),
              sURLVariables = sPageURL.split('&'),
              sParameterName,
              i;
      
          for (i = 0; i < sURLVariables.length; i++) {
              sParameterName = sURLVariables[i].split('=');
      
              if (sParameterName[0] === sParam) {
                  return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
              }
          }
          return false;
      };
  
      // if ($('.product-grid-item .product-grid-item__title').length){
      //     $('.product-grid-item .product-grid-item__title').matchHeight();
      // }
      if ($('.product-grid-item .product-grid-item__info a.product-grid-item__rating').length){
          setTimeout(function(){
              $('.product-grid-item .product-grid-item__info a.product-grid-item__rating').matchHeight();
          }, 300);
      }
      if ($('body .product-grid-item .product-grid-item__title').length){
          setTimeout(function(){
              $('body .product-grid-item .product-grid-item__title').matchHeight();
          }, 300);
      }
  });

  //Custom reCharge
  var waitForEl = function (selector, callback) {
    if ($(selector).length) {
      callback();
    } else {
      setTimeout(function () {
        waitForEl(selector, callback);
      }, 100);
    }
  };
    
  waitForEl('.rc_container_wrapper', function () {
    if($('.rc_container_wrapper').length > 0){
      $('.subcribe-label').show();
    }
    var subcriptionElement = $('.subcribe-label').closest('.product__form').find('.rc_container_wrapper');
    var saveText = $('.save-text').text() + ' ' + $('.rc_widget__option__discount').text();
    $('.rc_widget__option__discount').text(saveText);
    $(subcriptionElement).insertAfter('.subcribe-label');
    $('.rc_widget__price--onetime').each(function (index, obj) {
      var originalPrice = $(obj).text();
      var originalPriceText = '<span class="rc-option__price rc_widget__price rc_widget__price--subsave original-price" aria-label="recurring price" data-price-subsave="">' + originalPrice + '</span>';
      var subsaveElement = $(obj).closest('.rc-template').find('.rc_widget__price--subsave');
      $(originalPriceText).insertAfter(subsaveElement);
    });
  });

  waitForEl('.pickup-availability-container', function () {
    $('<div class="two-column-contents"></div>').insertAfter('.product-form-border');
    $('.pickup-availability-container').appendTo('.two-column-contents');
  });
  waitForEl('giftflick-api', function () {
    $('giftflick-api').appendTo('.two-column-contents');
  });
/*
  waitForEl('.discount', function () {
    $('.discount').insertBefore('.product__description').show();
    $('.discount').insertAfter('.product__price-and-badge').show();
    if($('.product-info-popup').length > 0){
      var openHtml = '<span class="open-info-popup"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.71478 7.19143L6.66478 7.24143L6.86478 8.86143H7.67478L7.77478 8.05143C8.88478 7.86143 9.78478 7.29143 9.78478 6.02143C9.78478 4.76143 8.84478 3.98143 7.44478 3.98143C6.36478 3.98143 5.61478 4.43143 5.03478 5.09143L5.78478 5.89143C6.26478 5.38143 6.78478 5.10143 7.41478 5.10143C8.13478 5.10143 8.56478 5.49143 8.56478 6.06143C8.56478 6.73143 7.98478 7.14143 6.71478 7.19143ZM7.91478 11.0714V9.70143H6.57478V11.0714H7.91478Z" fill="#AE3939"/><circle cx="7.5" cy="7.5" r="7" stroke="#AE3939"/></svg></span>'
      $('.discount p').append(openHtml);
    }
  });*/

  if($('.jdgm-rev__timestamp').length > 0){
    $('.jdgm-rev__timestamp').each(function(){
      let formattedDate = moment($(this).attr('data-content')).format('MMM DD, YYYY');
      $(this).closest('.jdgm-rev__header').find('.jdgm-rev__author').text($(this).closest('.jdgm-rev__header').find('.jdgm-rev__author').text() + ' ' + $('.on-text').text() + ' ' + formattedDate);
    })
  }
  // $('.jdgm-rev__author-wrapper').insertAfter('.jdgm-rev__title');
  $('.jdgm-rev__author-wrapper').each(function(){
    $(this).insertAfter($(this).closest('.jdgm-rev').find('.jdgm-rev__content .jdgm-rev__title'));
  })

  $('body').on('click', '.rc-template__radio-group .rc-radio', function(){
    setTimeout(function(){
      $('.product__form .btn--submit span[data-money-convertible]').text($('.product__price--regular').text());
    }, 300);
  })

  $('body').on('click', '.discount', function(){
    $('.product-info-popup').fadeIn();
  });
  
  $('body').on('click', '.product-info-popup .info-popup-inner .close-button, .product-info-popup .blur-background', function(){
    $('.product-info-popup').fadeOut();
  });

  document.querySelectorAll('.box-item').forEach(boxItem => {
  boxItem.addEventListener('click', function() {
    const boxDesc = this.querySelector('.box-desc');
    boxDesc.classList.toggle('active');
  });
document.querySelectorAll(".box-item").forEach(box => {
    const desc = box.querySelector(".box-desc");
    const name = box.querySelector(".box-name");

    if (desc && desc.textContent.trim() !== "") {
        box.style.cursor = "pointer";
        if (name) {
            name.style.fontWeight = "500";
        }
    }
});
});

  $(window).on('change resize load orientationchange', function(){
      // if ($('.product-grid-item .product-grid-item__title').length){
      //     setTimeout(function(){
      //         $('.product-grid-item .product-grid-item__title').matchHeight();
      //     }, 300);
      // }
      if ($('.product-grid-item .product-grid-item__info a.product-grid-item__rating').length){
          setTimeout(function(){
              $('.product-grid-item .product-grid-item__info a.product-grid-item__rating').matchHeight();
          }, 300);
      }
      if ($('body .product-grid-item .product-grid-item__title').length){
          setTimeout(function(){
              $('body .product-grid-item .product-grid-item__title').matchHeight();
          }, 300);
      }

    
  })
  
  $(window).on('load', function(){
      setTimeout(function(){
        waitForEl('body .rc-template__radio-group .rc-radio.rc-option__onetime .rc-radio__label .rc-option__price.rc_widget__price--onetime', function () {
          var originalPrice = $('body .rc-template__radio-group .rc-radio.rc-option__onetime .rc-radio__label .rc-option__price.rc_widget__price--onetime').text();
          $('<div class="two-column-price"></div>').insertAfter('.rc-template__radio-group .rc-radio.rc-option__subsave .rc-radio__label .rc-option__discount');
          $('body .rc-template__radio-group .rc-radio.rc-option__subsave .rc-radio__label .rc-option__price').appendTo('.two-column-price');
           $('<span class="rc-option__price rc_widget__price rc_widget__price--subsave original-price original-price-new">' + originalPrice + '</span>').appendTo('.two-column-price');
        });
        waitForEl('.rc-template__radio-group .rc-selling-plans', function () {
          var subscribeNotification = $('.subscribe-notification-text').html();
          $(subscribeNotification).insertBefore('body .rc-selling-plans__label');
        })
      }, 300);
   
      // move message input box from sticky form to main form
      var idMoveMessageBox = 0;
      var moveMessageBox = setInterval(function(){
          if ($('.template-product .product__form_sticky #infiniteoptions-container textarea').length){
              $('.template-product .product__form_sticky #infiniteoptions-container textarea').attr({'placeholder': 'Write a message', 'maxlength': '300'});
          }
          if ($('.template-product .product__form_sticky #infiniteoptions-container textarea').length){
              if ($('.template-product .product__form').length && $('.template-product .product__form #infiniteoptions-container textarea').length == 0 ) {
                  let messageBox = $('.template-product .product__form_sticky #infiniteoptions-container').clone(true);
                  messageBox.prependTo('.template-product .product__form');
              }
              idMoveMessageBox = 1;
              clearInterval(moveMessageBox);
          }
      }, 50);
      setTimeout(function(){
          if (idMoveMessageBox == 0 && typeof moveMessageBox != 'number'){
              clearInterval(moveMessageBox);
          }     
      }, 20000);
      // end -move message input box from sticky form to main form

      //sync content between message box
      $('.template-product').on('keyup', '.product__form #infiniteoptions-container textarea', function(){
          $('.template-product .product__form_sticky #infiniteoptions-container textarea').val($(this).val()).trigger('change');
      });

      //Click rating under product name, scroll to review section
      $('body').on('click', '.product-single__details .product__rating', function(){
          if ($('#judgeme_product_reviews').length) {
              $("html,body").animate({scrollTop: $('#judgeme_product_reviews').offset().top - 150}, 1000);  
          } 
      });
  })
})(jQuery)